import 'angular:locale/data:nl';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
